// @ts-nocheck
/* ============================================================
   COLLECTION FILTERS — collection-filters.js
   Barra de categorías + buscador para /collections/all.

   Todo client-side sobre lo que ya está en el DOM: la grilla nativa
   de Shopify (product-grid) sigue haciendo scroll infinito normal,
   este script solo muestra/oculta <li> ya renderizados según la
   categoría activa y el texto de búsqueda — no hay llamada a
   servidor ni segunda fuente de datos.

   Como el scroll infinito puede agregar más <li> después de cargar
   la página, un MutationObserver re-aplica el filtro activo a
   cualquier tarjeta nueva que aparezca.

   Link directo a una categoría: la categoría activa se refleja en la
   URL como ?categoria=sillas (o mesas / sofa-cama / reloj), así que
   cualquier pestaña se puede compartir por WhatsApp tal cual quede en
   la barra de direcciones después de hacer clic — no hace falta una
   página aparte por categoría.
   ============================================================ */

(function () {
  'use strict';

  var URL_PARAM = 'categoria';

  function init(root) {
    var tabsEl   = root.querySelector('[data-cf-tabs]');
    var searchEl = root.querySelector('[data-cf-search]');
    var emptyEl  = root.querySelector('[data-cf-empty]');
    var toastEl  = root.querySelector('[data-cf-toast]');

    if (!tabsEl) return;

    var toastTimer = null;
    function showToast(message) {
      if (!toastEl) return;
      toastEl.textContent = message;
      toastEl.hidden = false;
      // Forzar reflow para que el navegador registre el estado inicial
      // (hidden -> visible) antes de aplicar la transición de entrada.
      void toastEl.offsetWidth;
      toastEl.setAttribute('data-cf-toast-visible', '');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toastEl.removeAttribute('data-cf-toast-visible');
        setTimeout(function () { toastEl.hidden = true; }, 200);
      }, 1800);
    }

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* nada más que hacer */ }
      document.body.removeChild(ta);
      return Promise.resolve();
    }

    tabsEl.addEventListener('click', function (e) {
      var shareBtn = e.target.closest('[data-cf-share]');
      if (!shareBtn) return;
      var shareUrl = shareBtn.dataset.cfShareUrl;
      if (!shareUrl) {
        var url = new URL(window.location.href);
        url.search = '';
        url.searchParams.set(URL_PARAM, shareBtn.dataset.cfShare);
        shareUrl = url.toString();
      }
      copyText(shareUrl).then(function () {
        showToast('Link copiado');
      }).catch(function () {
        showToast(shareUrl);
      });
    });

    var validCategories = Array.prototype.map.call(
      tabsEl.querySelectorAll('[data-cf-tab]'),
      function (b) { return b.dataset.cfTab; }
    );

    var initialCategory = 'all';
    var urlCategory = new URLSearchParams(window.location.search).get(URL_PARAM);
    if (urlCategory && validCategories.indexOf(urlCategory) !== -1) {
      initialCategory = urlCategory;
    }

    var state = { category: initialCategory, query: '' };

    function setActiveTabUI(category) {
      tabsEl.querySelectorAll('[data-cf-tab]').forEach(function (b) {
        b.classList.toggle('cf__tab--active', b.dataset.cfTab === category);
      });
    }

    function updateUrl(category) {
      var url = new URL(window.location.href);
      if (category === 'all') {
        url.searchParams.delete(URL_PARAM);
      } else {
        url.searchParams.set(URL_PARAM, category);
      }
      window.history.replaceState({}, '', url);
    }

    if (initialCategory !== 'all') {
      setActiveTabUI(initialCategory);
    }

    function items() {
      return document.querySelectorAll('.product-grid__item[data-cf-category]');
    }

    function applyToItem(item) {
      var cats  = (item.dataset.cfCategory || '').split(' ').filter(Boolean);
      var title = (item.dataset.cfTitle || '').toLowerCase();

      var matchesCategory = state.category === 'all' || cats.indexOf(state.category) !== -1;
      var matchesQuery = state.query === '' || title.indexOf(state.query) !== -1;

      var visible = matchesCategory && matchesQuery;
      if (visible) {
        item.removeAttribute('data-cf-hidden');
      } else {
        item.setAttribute('data-cf-hidden', 'true');
      }
      return visible;
    }

    function applyFilter() {
      var visibleCount = 0;
      items().forEach(function (item) {
        if (applyToItem(item)) visibleCount++;
      });
      if (emptyEl) emptyEl.hidden = visibleCount !== 0;
    }

    tabsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cf-tab]');
      if (!btn) return;
      state.category = btn.dataset.cfTab;
      setActiveTabUI(state.category);
      updateUrl(state.category);
      applyFilter();
    });

    if (searchEl) {
      var debounceTimer = null;
      searchEl.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          state.query = searchEl.value.trim().toLowerCase();
          applyFilter();
        }, 120);
      });
    }

    /* El scroll infinito de Shopify agrega <li> nuevos al mismo
       contenedor — les aplicamos el filtro activo apenas aparecen. */
    var container = document.querySelector('[data-testid="product-grid"]') || document.body;
    var observer = new MutationObserver(function (mutations) {
      var added = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.matches && node.matches('.product-grid__item[data-cf-category]')) {
            added = true;
          }
        });
      });
      if (added) applyFilter();
    });
    observer.observe(container, { childList: true, subtree: true });

    applyFilter();
  }

  function boot() {
    document.querySelectorAll('[data-cf-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
